import { Grid } from "semantic-ui-react";

interface IContactCardDetails {
  contactFields: { name: string; value: string | JSX.Element | null }[];
}

export function ContactCardLongDetails({ contactFields }: IContactCardDetails) {
  return (
    <Grid>
      {contactFields.map((field, index) => {
        if (!field.value) return;
        return (
          <Grid.Row className='tw-mt-5 tw-p-0' key={index} columns={2}>
            <Grid.Column width={4} className='tw-max-w-80'>
              {field.name}
            </Grid.Column>
            <Grid.Column width={12}>
              <p className='tw-break-words tw-font-bold'>{field.value}</p>
            </Grid.Column>
          </Grid.Row>
        );
      })}
    </Grid>
  );
}

export function ContactCardDetailsMobileView({ contactFields }: IContactCardDetails) {
  return (
    <div>
      {contactFields.map((field) => {
        if (!field.value) return;
        return (
          <div key={field.name} className='tw-mb-4 tw-flex-col'>
            <span className='tw-block'>{field.name}</span>
            <span className='tw-block tw-font-bold'>{field.value}</span>
          </div>
        );
      })}
    </div>
  );
}
